var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['content', _vm.classClose],on:{"click":_vm.toggle}},[(!_vm.showFrame2 && (_vm.template.frame == 1 || !_vm.template.name))?_c('Stage1',{attrs:{"template":_vm.template},on:{"end":_vm.nextFrame}}):_vm._e(),(_vm.showFrame2 || _vm.template.frame == 2)?_c('Stage2',{attrs:{"template":_vm.template},on:{"end":_vm.nextFrame}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }